import React from 'react';
import './Cards.css';
import CardItem from './CardItem';
import { FaFire, FaCoffee, FaBox, FaHeart } from 'react-icons/fa';
import { GiCoffeeBeans } from 'react-icons/gi';

function Cards() {
  return (
    <div className='cards'>
      <h1>WHAT YOU WILL EXPERIENCE</h1>
      <div className='cards__container'>
        <div className='cards__wrapper'>
          <ul className='cards__items'>
            <CardItem
              src={['images/process.JPG', 'images/wash process.webp', 'images/dryprocess.png']}
              text='You will learn all basics about the coffee beans'
              label='Knowledge'
              path='/booking'
              icon={<GiCoffeeBeans />}
            />
            <CardItem
              src={['images/roasting.jpg', 'images/roasting2-web.jpg']}
              text='Roast your first batch with careful guidance'
              label='Roasting'
              path='/booking'
              icon={<FaFire />}
            />
          </ul>
          <ul className='cards__items'>
            <CardItem
              src={['images/tasting-latte-web.jpg', 'images/pourover.jpg']}
              text='Make your own drink with your roasted beans'
              label='Tasting'
              path='/booking'
              icon={<FaCoffee />}
            />
            <CardItem
              src='images/packaging1.jpg'
              text='Pack and bring your beans home'
              label='Packaging'
              path='/booking'
              icon={<FaBox />}
            />
            <CardItem
              src={['images/couple1.JPG', 'images/IMG_8075.JPG', 'images/IMG_5919.JPG', 'images/IMG_5655.JPG']}
              text='A moment you will never forget'
              label='Memory'
              path='/booking'
              icon={<FaHeart />}
            />
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Cards;